import { render, staticRenderFns } from "./TooltipTitle.vue?vue&type=template&id=a28ce9d8&scoped=true&"
import script from "./TooltipTitle.vue?vue&type=script&lang=js&"
export * from "./TooltipTitle.vue?vue&type=script&lang=js&"
import style0 from "./TooltipTitle.vue?vue&type=style&index=0&id=a28ce9d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28ce9d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
